import { ArrowUpRight, Menu, X } from 'lucide-react'
import { useState, type ReactNode } from 'react'
import logo from '../../assets/images/logo.png'

const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.umdaventures.sandhi'

export function Header({ compact = false }: { compact?: boolean }) {
  const [open, setOpen] = useState(false)

  return (
    <header className={`site-header ${compact ? 'site-header--compact' : ''}`}>
      <div className="header-inner">
        <a className="brand" href="/" aria-label="Sandhi Card home">
          <img src={logo} alt="" />
          <span>sandhi</span>
        </a>
        <button className="menu-button" onClick={() => setOpen(!open)} aria-label="Toggle navigation" aria-expanded={open}>
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
        <nav className={open ? 'nav-links nav-links--open' : 'nav-links'} aria-label="Main navigation">
          <a href="/#how-it-works" onClick={() => setOpen(false)}>How it works</a>
          <a href="/#features" onClick={() => setOpen(false)}>Why Sandhi</a>
          <a href="/#faq" onClick={() => setOpen(false)}>Questions</a>
          <a className="nav-download" href={playStoreUrl} target="_blank" rel="noreferrer">
            Get the app <ArrowUpRight size={15} />
          </a>
        </nav>
      </div>
    </header>
  )
}

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div>
          <a className="brand brand--footer" href="/">
            <img src={logo} alt="" /><span>sandhi</span>
          </a>
          <p>Your professional identity,<br />ready whenever opportunity calls.</p>
        </div>
        <div className="footer-links">
          <div><span>Product</span><a href="/#features">Features</a><a href={playStoreUrl}>Android app</a></div>
          <div><span>Company</span><a href="/privacy">Privacy</a><a href="/terms">Terms</a><a href="/delete-account">Delete account</a></div>
          <div><span>Contact</span><a href="mailto:support@sandhicard.com">support@sandhicard.com</a><a href="mailto:privacy@sandhicard.com">privacy@sandhicard.com</a></div>
        </div>
      </div>
      <div className="footer-bottom"><span>© {new Date().getFullYear()} Sandhi Card</span><span>Made for better introductions.</span></div>
    </footer>
  )
}

export function PageShell({ children, compactHeader = false }: { children: ReactNode; compactHeader?: boolean }) {
  return <><Header compact={compactHeader} />{children}<Footer /></>
}
